module.exports = __webpack_public_path__ + "assets/img/btn-detail-9de28e87.png";